import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient } from '@tanstack/react-query'
import { AppRoutes, Providers } from './App.tsx'
import './index.css'
import { captureLeadSource } from './lib/leadSource'

declare global {
  interface Window {
    __REACT_QUERY_STATE__?: unknown;
  }
}

captureLeadSource();

const rootElement = document.getElementById("root");

if (rootElement) {
  const queryClient = new QueryClient();
  const dehydratedState = window.__REACT_QUERY_STATE__;

  const app = (
    <BrowserRouter>
      <Providers queryClient={queryClient} dehydratedState={dehydratedState}>
        <AppRoutes />
      </Providers>
    </BrowserRouter>
  );

  // Prerendered pages ship server-rendered markup in #root — hydrate it
  // instead of clobbering it with a fresh client render.
  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
  } else {
    createRoot(rootElement).render(app);
  }
}
